import styled, { css } from 'styled-components';
export const Tab = styled.div.attrs({
    role: 'tabpanel',
    tabIndex: -1,
}) ``;
const outline = css `
  #${(props) => props['aria-activedescendant']} {
    outline: var(--outline);
    outline-offset: -2px;
    z-index: 10;
    background: var(--color-overlay-hover-darken);
    > span {
      color: var(--color-primary-variant);
    }
  }
`;
export const TabBar = styled.div `
  display: flex;
  flex-direction: column;
  outline: none;
  position: relative;
  height: 44px;

  overflow-x: auto;
  overflow-y: hidden;
  max-width: 100%;

  scrollbar-width: none;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  &::-webkit-scrollbar {
    /* WebKit */
    width: 0;
    height: 0;
  }

  border-bottom: 1px solid var(--color-border);

  &:focus-visible {
    ${outline}
  }
  ${({ isUsingKeyboard }) => isUsingKeyboard &&
    css `
      &:focus,
      &:focus-within {
        ${outline}
      }
    `}

  &::-moz-focus-inner {
    border: 0;
  }
`;
export const ButtonsContainer = styled.div `
  display: flex;
  flex-wrap: nowrap;
`;
export const ButtonText = styled.span `
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  padding: 12px 16px;

  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  line-height: 24px;

  &::-moz-focus-inner {
    border: 0;
  }

  color: ${(props) => props.active ? 'var(--color-primary)' : 'var(--color-inactive)'};

  white-space: nowrap;

  @media (max-width: 768) {
    font-size: 14px;
  }
`;
export const Button = styled.button `
  box-sizing: border-box;

  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  color: var(--color-on-background);

  :hover {
    background: var(--color-overlay-hover-darken);
  }

  :hover ${ButtonText} {
    color: var(--color-primaryVariant);
  }

  :active {
    background: var(--color-overlay-hover-pressed);
  }

  :focus-visible {
    outline: none;
  }
  &[aria-disabled='true'] {
    cursor: not-allowed;

    :hover ${ButtonText} {
      color: var(--color-disabled);
    }

    ${ButtonText} {
      color: var(--color-disabled);
    }
  }
`;
export const ButtonUnderline = styled.span `
  background-color: var(--color-primary);
  height: 4px;
  width: ${({ width }) => `${width}px`};
  z-index: 1;
  bottom: 0px;
  transform-origin: left center 0px;
  position: absolute;
  transition:
    transform 200ms ease-in-out,
    width 200ms ease-in-out;
  transform: ${({ x }) => `translateX(${x}px)`};
`;
